import { FieldProps } from 'formik';
import { ReactElement, useMemo } from 'react';
import { getFormikProps } from 'views/declarations/utils/form-utils';
import { useTranslation } from 'react-i18next';
import DeclarationField from '../../../common/DeclarationField';
import FormInput from 'components/ui/composed/declarations/formInput/DeclarationInput';
import { validators } from '../../export/validations/validations';
import FormSelect from '../../../../../components/ui/composed/declarations/formSelect';
import useCodelists from '../../../../../hooks/useCodelists';
import HideComponent from '../../../../../utils/HideComponent';

type Fields = 'payment.paymentAmount' | 'payment.paymentAmountCurrencyId';

export const calculationOfTaxesBlockValidation = {
    childValidators: {
        'payment.paymentAmount': [validators.required(), validators.number(), validators.float(16, 2)],
        'payment.paymentAmountCurrencyId': [validators.required(), validators.exact(3)],
    },
};

interface Props extends BlockProps<Fields> {}

const CalculationOfTaxesBlock = ({ path = 'commodity.dutyTaxFee', fieldOptions, hide }: Props): ReactElement => {
    const { t } = useTranslation('form');
    const { cdsCodelists } = useCodelists();

    const ucc = useMemo(() => '4/6', []);

    return (
        <HideComponent hide={hide}>
            <DeclarationField pathPrefix={path} name="payment.paymentAmount">
                {({ form, field }: FieldProps<any>) => (
                    <FormInput
                        required
                        refNumber={ucc}
                        label={t('calculationOfTaxesPayableTaxAmount')}
                        {...getFormikProps(field.name, form)}
                        condensed
                    />
                )}
            </DeclarationField>

            <DeclarationField pathPrefix={path} name="payment.paymentAmountCurrencyId">
                {({ form, field }: FieldProps<any>) => (
                    <FormSelect
                        required
                        refNumber={ucc}
                        label={t('calculationOfTaxesTaxTypePayableTaxAmountCurrency')}
                        {...getFormikProps(field.name, form)}
                        condensed
                        selectOptions={cdsCodelists?.exchangeRateCurrencies}
                        codeValidation={[validators.exact(3)]}
                    />
                )}
            </DeclarationField>
        </HideComponent>
    );
};

export default CalculationOfTaxesBlock;
